import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function MagicConsume() {
  const { token } = useParams();
  const { consumeMagic } = useAuth();
  const nav = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    (async () => {
      try {
        const user = await consumeMagic(token);
        setState("ok");
        toast.success("Inloggad!");
        setTimeout(() => nav(user.role === "member" ? "/hem" : "/admin", { replace: true }), 900);
      } catch (err) {
        setState("error");
        setMsg(formatApiErrorDetail(err.response?.data?.detail) || "Länken kunde inte användas");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-5 py-10">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8 text-center">
        {state === "loading" && (
          <div data-testid="magic-consuming">
            <div className="w-12 h-12 rounded-full border-4 border-slate-200 border-t-[#E1251B] animate-spin mx-auto mb-4"/>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Loggar in…</h2>
            <p className="text-sm text-slate-500 mt-2">Ett ögonblick.</p>
          </div>
        )}
        {state === "ok" && (
          <div data-testid="magic-ok">
            <div className="w-14 h-14 rounded-full bg-emerald-100 mx-auto flex items-center justify-center mb-4">
              <CheckCircle2 className="text-emerald-600" size={28}/>
            </div>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Välkommen!</h2>
            <p className="text-sm text-slate-500 mt-2">Skickar dig vidare…</p>
          </div>
        )}
        {state === "error" && (
          <div data-testid="magic-error">
            <div className="w-14 h-14 rounded-full bg-rose-100 mx-auto flex items-center justify-center mb-4">
              <XCircle className="text-rose-600" size={28}/>
            </div>
            <h2 className="font-heading text-2xl font-extrabold text-slate-900">Länken fungerade inte</h2>
            <p className="text-sm text-slate-600 mt-2">{msg}</p>
            <Link to="/login" className="inline-block mt-6 text-sm font-semibold text-[#E1251B] hover:underline">Begär en ny inloggningslänk</Link>
          </div>
        )}
      </div>
    </div>
  );
}
